var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStringAsc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.54102 9.24219H5.45898L4.87305 11H3.00391L6.17969 2.46875H7.80859L11.002 11H9.13281L8.54102 9.24219ZM5.93359 7.81836H8.06641L6.99414 4.625L5.93359 7.81836Z",
    fill: "#6B92FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.98633 20.5879H10.2871V22H3.78906V20.9688L8.00781 14.8926H3.79492V13.4688H10.1934V14.4766L5.98633 20.5879Z",
    fill: "#B8C6E3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17 3C17 2.44772 17.4477 2 18 2C18.5523 2 19 2.44772 19 3L19 18.5858L20.2929 17.2929C20.6834 16.9024 21.3166 16.9024 21.7071 17.2929C22.0976 17.6834 22.0976 18.3166 21.7071 18.7071L18.7071 21.7071C18.3166 22.0976 17.6834 22.0976 17.2929 21.7071L14.2929 18.7071C13.9024 18.3166 13.9024 17.6834 14.2929 17.2929C14.6834 16.9024 15.3166 16.9024 15.7071 17.2929L17 18.5858L17 3Z",
    fill: "#6B92FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStringAsc);
export default __webpack_public_path__ + "static/media/string-asc.46374803.svg";
export { ForwardRef as ReactComponent };